module.exports = __webpack_public_path__ + "de7f72b95a4d11a47256d562a8bb6fbf.ttf";